export default {
  en: {
    micSilent: "We didn't hear anything — check your microphone settings",
    progress: 'Question {{current}} of {{total}}',
    recognizing: 'Recognizing…',
    typing: 'Tutor is typing',
    notHeard: "Couldn't hear anything",
    listen: 'Listen again',
    deleteRecording: 'Delete recording',
    typeText: 'Type instead',
    backToVoice: 'Back to voice',
    typePlaceholder: 'Write your answer in {{nom}}',
    yourAnswer: 'Your answer',
    send: 'Send',
    micUnavailable: 'Microphone unavailable — type your answer instead',
    failed: "That answer didn't go through. Try answering again.",
    pronunciation: 'Pronunciation',
    vocabulary: 'Vocabulary',
    grammar: 'Grammar',
    fluency: 'Fluency',
    fillerWords: 'Filler words',
    finish: 'Finish the check',
  },
  ru: {
    micSilent: 'Мы ничего не услышали — проверь настройки микрофона',
    progress: 'Вопрос {{current}} из {{total}}',
    recognizing: 'Распознаю…',
    typing: 'Репетитор печатает',
    notHeard: 'Ничего не расслышал',
    listen: 'Послушать ещё раз',
    deleteRecording: 'Удалить запись',
    typeText: 'Ввести текстом',
    backToVoice: 'Вернуться к голосу',
    typePlaceholder: 'Напиши ответ {{adv}}',
    yourAnswer: 'Твой ответ',
    send: 'Отправить',
    micUnavailable: 'Микрофон недоступен — набери ответ текстом',
    failed: 'Ответ не дошёл. Попробуй ответить ещё раз.',
    pronunciation: 'Произношение',
    vocabulary: 'Словарный запас',
    grammar: 'Грамматика',
    fluency: 'Беглость речи',
    fillerWords: 'Слова-паразиты',
    finish: 'Завершить проверку',
  },
  de: {
    micSilent: 'Wir haben nichts gehört — prüf die Mikrofoneinstellungen',
    progress: 'Frage {{current}} von {{total}}',
    recognizing: 'Spracherkennung…',
    typing: 'Der Tutor schreibt',
    notHeard: 'Ich habe nichts gehört',
    listen: 'Noch einmal anhören',
    deleteRecording: 'Aufnahme löschen',
    typeText: 'Stattdessen tippen',
    backToVoice: 'Zurück zur Stimme',
    typePlaceholder: 'Schreibe deine Antwort auf {{nom}}',
    yourAnswer: 'Deine Antwort',
    send: 'Senden',
    micUnavailable: 'Mikrofon nicht verfügbar — tippe deine Antwort stattdessen ein',
    failed: 'Die Antwort ist nicht angekommen. Versuch es noch einmal.',
    pronunciation: 'Aussprache',
    vocabulary: 'Wortschatz',
    grammar: 'Grammatik',
    fluency: 'Sprechflüssigkeit',
    fillerWords: 'Füllwörter',
    finish: 'Check beenden',
  },
  pt: {
    micSilent: 'Não ouvimos nada — verifique as configurações do microfone',
    progress: 'Pergunta {{current}} de {{total}}',
    recognizing: 'Reconhecendo…',
    typing: 'O tutor está digitando',
    notHeard: 'Não escutei nada',
    listen: 'Ouvir de novo',
    deleteRecording: 'Excluir gravação',
    typeText: 'Responder por texto',
    backToVoice: 'Voltar para a voz',
    typePlaceholder: 'Escreva sua resposta em {{nom}}',
    yourAnswer: 'Sua resposta',
    send: 'Enviar',
    micUnavailable: 'Microfone indisponível — digite sua resposta no lugar',
    failed: 'A resposta não foi enviada. Tente responder de novo.',
    pronunciation: 'Pronúncia',
    vocabulary: 'Vocabulário',
    grammar: 'Gramática',
    fluency: 'Fluência',
    fillerWords: 'Palavras de preenchimento',
    finish: 'Finalizar o teste',
  },
  fr: {
    micSilent: 'Nous n’avons rien entendu — vérifie les réglages du micro',
    progress: 'Question {{current}} sur {{total}}',
    recognizing: 'Reconnaissance…',
    typing: 'Le tuteur écrit',
    notHeard: 'Je n’ai rien entendu',
    listen: 'Réécouter',
    deleteRecording: 'Supprimer l’enregistrement',
    typeText: 'Répondre par écrit',
    backToVoice: 'Revenir à la voix',
    typePlaceholder: 'Écris ta réponse en {{nom}}',
    yourAnswer: 'Ta réponse',
    send: 'Envoyer',
    micUnavailable: 'Micro indisponible — écris plutôt ta réponse',
    failed: 'Ta réponse n’est pas arrivée. Essaie de répondre à nouveau.',
    pronunciation: 'Prononciation',
    vocabulary: 'Vocabulaire',
    grammar: 'Grammaire',
    fluency: 'Fluidité',
    fillerWords: 'Mots de remplissage',
    finish: 'Terminer le test',
  },
  es: {
    micSilent: 'No oímos nada — revisa la configuración del micrófono',
    progress: 'Pregunta {{current}} de {{total}}',
    recognizing: 'Reconociendo…',
    typing: 'El tutor está escribiendo',
    notHeard: 'No escuché nada',
    listen: 'Escuchar de nuevo',
    deleteRecording: 'Eliminar la grabación',
    typeText: 'Responder por escrito',
    backToVoice: 'Volver a la voz',
    typePlaceholder: 'Escribe tu respuesta en {{nom}}',
    yourAnswer: 'Tu respuesta',
    send: 'Enviar',
    micUnavailable: 'Micrófono no disponible — escribe tu respuesta en su lugar',
    failed: 'La respuesta no llegó. Intenta responder de nuevo.',
    pronunciation: 'Pronunciación',
    vocabulary: 'Vocabulario',
    grammar: 'Gramática',
    fluency: 'Fluidez',
    fillerWords: 'Muletillas',
    finish: 'Terminar la prueba',
  },
};
